import { render, staticRenderFns } from "./TextImageBlock.vue?vue&type=template&id=38064eea"
import script from "./TextImageBlock.vue?vue&type=script&lang=ts"
export * from "./TextImageBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports